import React, {createContext, useState, useContext, ReactNode } from 'react';

interface WebsiteContextProps{
   value :any;
   setValue : (newValue:any)=>void;
}

const WebsiteContext = createContext< WebsiteContextProps | undefined>(undefined);


const WebsiteProvider : React.FC<{children:ReactNode}> = ({ children})=> {
 const [value,setValue] = useState<any>('');
 return(
    <WebsiteContext.Provider value={{ value,setValue}}>
        {children}
     </WebsiteContext.Provider>
 );
}

export { WebsiteContext, WebsiteProvider}